<template>
  <b-modal title="بحث عن منظمة" footer-class="removed" v-model="isModalOpened">
    <form-input rules="required" label="اسم المنظمة" v-model="ngoName" />
    <div class="search-container">
      <div
        v-if="loading"
        style="height: 80px"
        class="d-flex justify-content-center align-items-center"
      >
        <b-spinner
          class="mx-1"
          style="width: 2rem; height: 2rem"
          variant="info"
        />
        <h6 class="text-info">جاري التحميل...</h6>
      </div>

      <template
        v-if="getOrg.data.length === 0 && ngoName.length > 0 && !loading"
      >
        <div
          class="text-center my-3 d-flex flex-column justify-content-center align-items-center"
        >
          <div>
            <feather-icon size="60" icon="AlertOctagonIcon" />
          </div>
          <div class="h4 mt-1">لا توجد نتائج مطابقة لبحثك</div>
        </div>
      </template>

      <template v-if="getOrg.data.length > 0 && ngoName.length > 0 && !loading">
        <div class="ngo-cont">
          <b-list-group flush>
            <b-list-group-item
              v-for="ngo in getOrg.data"
              :key="ngo.id"
              class="d-flex py-25 align-items-center"
              :to="`/ngo/${ngo.id}`"
              @click="isModalOpened = false"
            >
              <span class="mr-1">
                <img
                  height="30"
                  :src="ngo.logo"
                  :alt="`شعار منظمة ${ngo.name_ar}`"
                />
              </span>
              <span>{{ ngo.name_ar }}</span>
            </b-list-group-item>
          </b-list-group>
        </div>
      </template>
      <template
        v-if="
          (getOrg.data.length <= 0 ||
            (getOrg.data.length > 0 && ngoName.length === 0)) &&
          !loading
        "
      >
        <h6 class="mb-1">منظمات مقترحة :</h6>
        <b-list-group flush>
          <b-list-group-item
            v-for="ngo in similarNgos.slice(0, 4)"
            :key="ngo.id"
            class="d-flex py-25 align-items-center"
            :to="`/ngo/${ngo.id}`"
            @click="isModalOpened = false"
          >
            <span class="mr-1">
              <img
                height="30"
                :src="ngo.logo"
                :alt="`شعار منظمة ${ngo.name_ar}`"
              />
            </span>
            <span>{{ ngo.name_ar }}</span>
          </b-list-group-item>
        </b-list-group>
      </template>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { BListGroup, BListGroupItem, BSpinner } from "bootstrap-vue";
import FormInput from "@/components/form-input";
import debounce from "lodash.debounce";

export default {
  props: {
    value: Boolean,
  },
  components: {
    BListGroup,
    BListGroupItem,
    FormInput,
    BSpinner,
  },
  data() {
    return {
      ngoName: "",
    };
  },
  computed: {
    ...mapGetters("NgoHome/ngos", ["similarNgos"]),
    isModalOpened: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    getOrg() {
      return this.$store.getters["NgoHome/main/ngoOrganizations"];
    },
    loading() {
      return this.$store.getters["NgoHome/main/loadingOrg"];
    },
  },
  methods: {
    ...mapActions("NgoHome/ngos", ["getSimilarNgo"]),
  },

  watch: {
    ngoName: debounce(function (value) {
      this.$store.dispatch(`NgoHome/main/getOrganizations`, {
        currentPage: 1,
        filter: value,
      });
    }, 500),
    value(val) {
      if (val) this.getSimilarNgo(this.$route.params.id);
    },
  },
};
</script>

<style lang="scss">
.search-container {
  height: 400px;
  overflow: auto;
}
</style>
